import { useConversationDetail } from "./useConversationDetail";

export type ConversationAgent = {
    agentId: number | undefined;
    agentName: string | undefined;
};

/**
 * Read the current conversation's agent (`agent_id` / `agent_name`) off
 * the same ConversationDetail query that `useAccessMode` already warms,
 * so mounting this hook alongside it incurs no extra network round-trip.
 *
 * Pending and error states return `{ undefined, undefined }` so the
 * obvious caller pattern (`agentName ? <Chip /> : null`) renders nothing
 * until the value is known; same fail-closed posture as the access-mode
 * gate, no optimistic render.
 */
export function useConversationAgent(
    remoteId: number | string | undefined
): ConversationAgent {
    const { data } = useConversationDetail(remoteId);

    if (!data) {
        return { agentId: undefined, agentName: undefined };
    }
    return {
        // The wire sends null for BOTH fields on agent-less conversations;
        // normalize to undefined so the public contract stays "agent or
        // nothing" (the same posture as the pending/error return above).
        agentId: data.agent_id ?? undefined,
        agentName: data.agent_name ?? undefined,
    };
}
